import { createFileRoute } from "@tanstack/react-router";

import { AdminMailingScreen } from "@/features/admin/screens/AdminMailing";

export const Route = createFileRoute("/_authenticated/(admin)/admin/mailing")({
  component: AdminMailingScreen,
});
